import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { authIsAuthenticated, authUser } from "../../../../redux/selectors/authSelectors";

import { Outlet, useNavigate, useOutletContext } from "react-router-dom";
import useRecommendations from "../../../../hooks/useRecommendations";
import "./Recommendations.scss";
import bookmarkBlankIco from "../../../../assets/bookmarkBlankIco.svg";

import { AffiliateCodeModal, ChoosePlanFirstModal } from "../../../../modals";
import CareersHeader from "./components/CareersHeader/CareersHeader";
import Card from "./components/Card/Card";
import Loader from "../../../../components/Loader";
import { PlusIco } from "../../../../components/icons";
import FindCareer from "../../../../modals/FindCareer";
import BaseModal from "../../../../modals/BaseModal";
import useAffiliateCodeModal from "../../../../hooks/useAffiliateCodeModal";
import { isAccessFeature } from "../../../../common/utils";

const Recommendations = () => {
  const [interestedCareers, setInterestedCareers] = useState([]);
  const [isOpenAddSearchCareer, setIsOpenAddSearchCareer] = useState(false);
  const navigate = useNavigate();
  const { user } = useOutletContext();
  const authUserData = useSelector(authUser) || {};
  const { role } = authUserData;
  const { results, isLoading } = useRecommendations();
  const isErrorPricing = isAccessFeature({...user,role});
  const educatorDashboardUrl = (
    process.env.REACT_APP_EDUCATOR_URL &&
    typeof process.env.REACT_APP_EDUCATOR_URL === "string"
  )
    ? `${process.env.REACT_APP_EDUCATOR_URL.replace(/\/$/, "")}/dashboard`
    : "";
  const {
    affiliateCodeModal,
    choosePlanFirstOpen,
    closeAffiliateCodeModal,
    closeChoosePlanFirstModal,
    confirmChoosePlanFirstModal,
    openAffiliateCodeModal,
    setAffiliateCode,
    submitAffiliateCode,
  } = useAffiliateCodeModal(user);
  const isAuth = useSelector((state) => authIsAuthenticated(state));
  useEffect(() => {
    if (!isAuth) {
      navigate("/signin?redirect=/profile/recommendations");
    }
  });
  useEffect(() => {
    if (results && results.length > 0) {
      const interestedCareers = results?.filter((item) => !!item?.interested);
      setInterestedCareers(interestedCareers);
    }
  }, [results]);
  const handleAddSearchCareer = () => {
    setIsOpenAddSearchCareer(!isOpenAddSearchCareer);
  };
  const handleStartNew = () => {
    if (!isErrorPricing.code_active) {
      openAffiliateCodeModal();
    } else {
      navigate("/scenario/0");
    }
  };

  return (
    <div className="recommendations_container">
      {results?.length && isErrorPricing.code_active ? (
        <>
          <CareersHeader careers={interestedCareers} />
          <div className="recommendations_consideration">
            <img src={bookmarkBlankIco} alt="bookmark icon" />
            <h4 className="recommendations_consideration__title">
              Careers to Consider
            </h4>
          </div>
          <div className="Recommendations-cont">
            {results
              ?.filter((el) => !el?.interested && el?.sort_decision !== "skip")
              ?.map((el, key) => {
                return <Card el={el} key={key} />;
              })}
            {isErrorPricing.new_plan_active && (
              <button
                onClick={handleAddSearchCareer}
                className="Recommendations-cont__item Recommendations-cont__item__addCareer"
              >
                <PlusIco />
                <p>Search & Add a Career</p>
              </button>
            )}
          </div>
        </>
      ) : isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="emptyMyFeedback-cont">
            {role === "Mentor" ? (
              <div className="mentorWelcomeCard">
                <p className="mentorWelcomeCard__title">Welcome to Career Scoops</p>
                <p className="mentorWelcomeCard__text">
                  Thank you for being part of a growing community dedicated to helping young people gain greater
                  clarity, confidence, and direction for their future. Your support helps create
                  meaningful opportunities and stronger outcomes.
                </p>
                <p className="mentorWelcomeCard__text">
                  Our team will continue coordinating the next steps and resources with you as needed.
                </p>
                <p className="mentorWelcomeCard__text mentorWelcomeCard__linkRow">
                  <span className="mentorWelcomeCard__label">Educator Dashboard:</span>{" "}
                  {educatorDashboardUrl ? (
                    <a
                      href={educatorDashboardUrl}
                      className="mentorWelcomeCard__link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Access Here
                    </a>
                  ) : (
                    <span className="mentorWelcomeCard__muted">Link will appear once configured.</span>
                  )}
                </p>
                <p className="mentorWelcomeCard__text mentorWelcomeCard__note">
                  Please note: If you are new to the platform, dashboard access and activation may take up to 24 hours.
                </p>
                <p className="mentorWelcomeCard__text mentorWelcomeCard__closing">We're excited to have you with us</p>
              </div>
            ) : (
              <>
                <p className="emptyMyFeedback-cont__text">
                  You don't have any recommendations yet
                </p>
                <div className="d-flex emptyMyFeedback-cont__btns">
                  <button
                    className="emptyMyFeedback-cont__btn"
                    onClick={handleStartNew}
                  >
                    <span
                      // to="/scenario/0"
                      className="emptyMyFeedback-cont__btn__text"
                    >
                      Start Test Now
                    </span>
                  </button>
                  <button
                    className="EditProfileCont__btnCont__btnSaveChange emptyMyFeedback__btn"
                    onClick={() => navigate("/profile/ai-companions")}
                  >
                    <span
                      // to="/scenario/0"
                      className="EditProfileCont__btnCont__btnSaveChange__text"
                    >
                      Meet Your AI Companions
                    </span>
                  </button>
                </div>
              </>
            )}
          </div>
        </>
      )}
      <ChoosePlanFirstModal
        isOpened={choosePlanFirstOpen}
        onClose={closeChoosePlanFirstModal}
        onContinue={confirmChoosePlanFirstModal}
      />
      <AffiliateCodeModal
        {...affiliateCodeModal}
        onBack={closeAffiliateCodeModal}
        onChange={setAffiliateCode}
        onSuccessClose={() =>
          results?.length
            ? closeAffiliateCodeModal()
            : navigate(
                isErrorPricing.code_active
                  ? "/scenario/0"
                  : "/pricingplan",
              )
        }
        onPricingPlanClick={() => {
          closeAffiliateCodeModal();
          navigate("/pricingplan");
        }}
        onSubmit={submitAffiliateCode}
      />
      <BaseModal
        className="Find__career__container"
        isOpen={isOpenAddSearchCareer}
        onClose={handleAddSearchCareer}
      >
        <FindCareer />
      </BaseModal>
      <Outlet />
    </div>
  );
};

export default Recommendations;
